/**
 * The password requirements as received from the backend API call.
 */
export interface PasswordRequirements {
  minLength: number;
  maxLength: number;
  requireMixedCase: boolean;
  requireNumber: boolean;
  requireNonAlpha: boolean;
}

/**
 * Meant to store whether the various and sundry password requirements are met.
 */
export interface PasswordRequirementChecks {
  equal: boolean;
  minLengthSatisfied: boolean;
  maxLengthSatisfied: boolean;
  mixedCaseSatisfied?: boolean;
  numberSatisfied?: boolean;
  nonAlphaSatisfied?: boolean;
}

export function isPasswordRequirements(
  data: unknown,
): data is PasswordRequirements {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const {
    minLength,
    maxLength,
    requireMixedCase,
    requireNumber,
    requireNonAlpha,
  } = data as PasswordRequirements;

  return (
    typeof minLength === "number" &&
    typeof maxLength === "number" &&
    typeof requireMixedCase === "boolean" &&
    typeof requireNumber === "boolean" &&
    typeof requireNonAlpha === "boolean"
  );
}
